<template>
  <div class="card">
    <section class="content-header">
      <div class="container-fluid">
        <spinnerProcessando cssClass="ml-2" :status="flagsDeControle.carregandoDados.status" :mensagem="flagsDeControle.carregandoDados.mensagem"/>
      </div><!-- /.container-fluid -->
    </section>
    <div class="card-header">
      <p class="card-title">Dados Escritorio</p>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-xl-6 col-lg-6 col-md-6 col-xs-12 col-sm-12">
          <div class="form-group">
            <label class="required">Nome do Escritório</label>
            <input
              v-model="formulario.nome"
              class="form-control"
            />
            <div v-if="listaDeErros['escritorio.nome']" class="text-danger">
              {{ listaDeErros["escritorio.nome"] }}
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-xs-12 col-sm-12">
          <div class="form-group">
            <label class="required">CPF/CNPJ</label>
            <input
              v-model="formulario.cpf_cnpj"
              v-mask="mascaraDocumento(formulario.cpf_cnpj)"
              maxlength="18"
              class="form-control campo-DocumentoCpfCnpjAlfanumericoUppercase"
            />
            <div v-if="listaDeErros['escritorio.cpf_cnpj']" class="text-danger">
              {{ listaDeErros["escritorio.cpf_cnpj"] }}
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-xs-12 col-sm-12">
          <div class="form-group">
            <label class="required">E-mail</label>
            <input
              v-model="formulario.email"
              class="form-control"
            />
            <div v-if="listaDeErros['escritorio.email']" class="text-danger">
              {{ listaDeErros["escritorio.email"] }}
            </div>
          </div>
        </div>
        <div class="col-xl-6 col-lg-6 col-md-6 col-xs-12 col-sm-12">
          <div class="form-group">
            <label class="required">Telefone/Celular</label>
            <TelefoneInput v-model="formulario.numero_telefone" class="form-control" :mask="mascaraFone(formulario.numero_telefone)"/>
            <div class="text-danger">
              {{ listaDeErros["escritorio.numero_telefone"] }}
            </div>
          </div>
        </div>
      </div>
      <hr />
      <Endereco :listaDeErros="mapearListaDeErros()" v-model="formulario.endereco" :flagsDeControle="flagsDeControle" :consultaUnidadesFederativas="obterUnidadesFederativas"></Endereco>
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-xs-12 col-sm-12">
          <div class="form-group">
            <label>
              <input type="checkbox" v-model="formulario.salvarDadosDoEscritorio" />
              Deseja salvar os dados do escritório?
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DadosEscritorio from './js/dados-escritorio'
export default DadosEscritorio
</script>
